exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-input-with-sign .append:after{content:attr(data-content);position:absolute;right:3%;top:6px}.text-input-with-sign .append input{padding-right:1.5em}.text-input-with-sign .prepend:before{content:attr(data-content);position:absolute;left:.5em;top:6px}.text-input-with-sign .prepend input{padding-left:1.5em}", ""]);

